class VideoKeywords {
  constructor(
    public uuid: string = "",
    public nameCourse: string = "",
    public nameChapter: string = "",
    public transcripts: Transcripts[] = new Array<Transcripts>(),
    public url: string = "",
    public nameVideo: string = "",
    public duration: number = 0
  ) {}
}

class Transcripts {
  constructor(
    public startTime: number = 0,
    public endTime: number = 0,
    public transcript: string = "",
    public keywords?: any[]
  ) {}
}

class BlackListKeywords {
  constructor(
    public uuid: string = "",
    public uuidCourse: string = "",
    public keyword: string = "",
    public keywordRank: number = 0,
    public score: number = 0,
    public usageCount: number = 0,
    public isGenerated: boolean = false,
    public isEval?: any
  ) {}
}

export { BlackListKeywords, Transcripts, VideoKeywords };
